class SensorLog {
  constructor() {
    // sdk的实例
    this.sensors = null

    // 页面/类型的公共数据
    this.commonOpt = null

    // 埋点队列
    this.logEventStack = []

    // 是否开发环境
    this.isDev = false

    // 是否打印埋点日志
    this.isLog = false
  }

  /**
   * 传入sdk中的sensor, 传入基础公共数据
   * @param {object} sensors
   * @param {boolean} isDev 设置环境
   * @param {boolean} isLog 是否开启埋点内容打印
   */
  init(sensors, isDev = false, isLog = false) {
    this.sensors = sensors
    this.isDev = isDev
    this.isLog = isLog
    if (isDev) {
      this.sensors.setEnv('dev', 'C')
    } else {
      this.sensors.setEnv('prod', 'C')
    }
  }

  /**
   * 添加全局的公共参数, 通常为客户端类型, 绑定手机的状态, 微信返回的union_id
   * @param params
   */
  register(params) {
    this.sensors.registerApp(params)
  }

  destroy() {
    this.sensors = null
    this.commonOpt = null
    this.logEventStack = []
  }

  getCommonOpt() {
    return this.commonOpt
  }

  /**
   * 设置公共数据, 进入直播间进行更新
   * @param commonOpt
   * @param {boolean} [isReplace=true] 是否替换, false则合并操作
   */
  setCommonOpt(commonOpt, isReplace = true) {
    // 是否在这里注入数据, 还是直接
    if (isReplace) {
      this.commonOpt = commonOpt
    } else {
      // 不能用展开合并对象
      this.commonOpt = Object.assign({}, this.commonOpt, commonOpt)
    }
  }

  /**
   * exOpt中的同名属性会覆盖commonOpt, 如果不使用公共参数, 可传递第三个参数为false
   * 或者设置commonOpt为null
   * @param {string} logEvent 事件名
   * @param {object} exOpt 指定的参数
   * @param {boolean} useCommonOpt 是否使用公共参数
   * @returns
   */
  sentLog(logEvent, exOpt, useCommonOpt = true) {
    if (!logEvent) return
    if (!this.commonOpt) {
      this.commonOpt = this.getCommonOpt()
    }
    // 这里应该copy一份commonOpt对象
    const trackData = {
      logEvent, exOpt
    }
    if (useCommonOpt) {
      trackData.commonOpt = Object.assign({}, this.commonOpt)
    } else {
      trackData.commonOpt = null
    }
    this.logEventStack.push(trackData)
    try {
      while (this.logEventStack.length > 0) {
        const {logEvent, exOpt, commonOpt} = this.logEventStack.shift()
        let logOpt = commonOpt
        if (exOpt) {
          logOpt = Object.assign({}, commonOpt, exOpt)
        }
        if (this.isLog) {
          console.log('埋点dev event:  ', logEvent, 'data: ', logOpt)
        }
        this.sensors.track(logEvent, logOpt)
      }
    } catch (e) {
      console.log('埋点错误', e)
    }
  }
}
const sensorLog = new SensorLog()
export default sensorLog
